export default __webpack_public_path__ + "static/coming-pc-a9e5b132b18ebfefd342a79624fea468.png";